import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import CallDetail from "@/pages/Pages/Call/CallDetail.vue";
import CallGroup from "@/pages/Pages/Call/CallGroup.vue";
import CallGroupIncoming from "@/pages/Pages/Call/CallGroupIncoming.vue";
import CallDetailIncoming from "@/pages/Pages/Call/CallDetailIncoming.vue";
import CallDetailIncomingInfo from "@/pages/Pages/Call/CallDetailIncomingInfo.vue";
import CallOriginatorRules from "@/pages/Pages/Call/CallOriginatorRules.vue";
import CallOriginatorRule from "@/pages/Pages/Call/CallOriginatorRule.vue";
let callMenu = {
  path: "/call",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  redirect: "/call/detail",
  name: "Call",
  children: [
    {
      path: "detail",
      name: "call_detail",
      components: { default: CallDetail },
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.call.detail'
      }
    },
    {
      path: "group",
      name: "call_group",
      components: { default: CallGroup },
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.call.group'
      }
    },
    {
      path: "detail_incoming",
      name: "call_detail_incoming",
      components: { default: CallDetailIncoming },
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.call.mo.detail'
      }
    },
    {
      path: "detail_incoming/:id",
      name: "call_detail_incoming_info",
      components: { default: CallDetailIncomingInfo },
      meta:{
        icon: "call",
        parentPath: "/call/detail_incoming",
        msgKey: 'menu.item.statistics.call.mo.detail'
      }
    },
    {
      path: "group_incoming",
      name: "call_group_incoming",
      components: { default: CallGroupIncoming },
      meta: {
        icon: "call",
        msgKey: 'menu.item.statistics.call.mo.group'
      }
    },
    {
      path: "originator_rules",
      name: "call_originator_rules",
      components: { default: CallOriginatorRules },
      meta:{
        icon: "call",
        msgKey: 'menu.item.call.pool.rules'
      }
    },
    {
      path: "originator_rules/new",
      name: "call_originator_rules_new",
      components: { default: CallOriginatorRule },
      meta:{
        icon: "call",
        parentPath: "/call/originator_rules",
        msgKey: 'menu.item.call.pool.rules'
      },
    },
    {
      path: "originator_rules/:id",
      name: "call_originator_rules_edit",
      components: { default: CallOriginatorRule },
      meta:{
        icon: "call",
        parentPath: "/call/originator_rules",
        msgKey: 'menu.item.call.pool.rules'
      }
    },
  ]
};

export default callMenu;
